import { render } from "./InventoryPorUbicacion.vue?vue&type=template&id=8bc5e638"
import script from "./InventoryPorUbicacion.vue?vue&type=script&lang=js"
export * from "./InventoryPorUbicacion.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__